interface RegionPromptProps {
    el: HTMLScriptElement;
}

const IS_ACTIVE_CLASS = 'is-active';

const RegionPrompt = ({ el }: RegionPromptProps): void => {
    const closeBtn = el.querySelector('[data-close]');

    if (!closeBtn) {
        return;
    }

    closeBtn.addEventListener('click', () => {
        el.classList.remove(IS_ACTIVE_CLASS);
    });
};

export default RegionPrompt;
